export const colors = {
    greyLight: '#E2E2E2',
    black: '#333333',
    error: '#DF5B5B',
    greyMedium: '#A3A3A3',
    greyDark: '#666666',
    orangeHover: '#C13F02',
    primary: '#FF5200',
    white: '#FFFFFF',
};
